__turbopack_context__.v({
  "card": "Move-module-scss-module__oZ7p-q__card",
  "container": "Move-module-scss-module__oZ7p-q__container",
  "content": "Move-module-scss-module__oZ7p-q__content",
  "eod-section": "Move-module-scss-module__oZ7p-q__eod-section",
  "how-it-works": "Move-module-scss-module__oZ7p-q__how-it-works",
  "img": "Move-module-scss-module__oZ7p-q__img",
  "recommend-bolt-description": "Move-module-scss-module__oZ7p-q__recommend-bolt-description",
  "section": "Move-module-scss-module__oZ7p-q__section",
  "video-wrapper": "Move-module-scss-module__oZ7p-q__video-wrapper",
});
